import React from 'react';

import { useGroupState, useGroupActions } from './GroupContext';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import DeleteGroupForm from './DeleteGroupForm';

const DeleteGroupModal = () => {
  const state = useGroupState();
  const { closeDeleteGroupModal } = useGroupActions();

  return (
    <StandardModal
      isOpen={state?.deleteGroupModalIsOpen}
      contentLabel="Delete Group"
      onRequestClose={() => {
        closeDeleteGroupModal();
      }}
    >
      <DeleteGroupForm />
    </StandardModal>
  );
};

export default DeleteGroupModal;
